//菜单：节假日管理页面
import React from 'react'
import Manager from '../../public/components/Manager'
import HolidayDiv from './HolidayDiv'
Ext.require('Ext.Toast')

const config = {
    buttons: [
        { icon: 'plus', text: '新增节假日...', handler: ({ showDetail, refreshPage }) => Tyan.pubForm.showDialog('节假日设置', props => <HolidayDiv {...props} id={0} onSave={refreshPage} />) },
    ],
    columns: [
        { _text: '节假日名称', field: 'HolidayName', minWidth: 200, locked: false },
        { _text: '放假规定', field: '_HolidayDiscription', minWidth: 150, flex: 9 },
    ],
    onDoubleTap: ({ showDetail, refreshPage }, data) => {
        Tyan.pubForm.showDialog('节假日设置', props => <HolidayDiv {...props} id={data.id} onSave={refreshPage} />)
    }
}

export default props => <Manager {...props} config={config} />